export default __webpack_public_path__ + "static/Distributed-Ledger-60ee2b6ed01b7fa43327b536608e449a.webp";